import moment from 'moment';
import { LinkToPay, AliPayCheckout, PaypalData } from '@/store/modules/linkToPay/types';
import Router from '@/router'
import loadOnce from 'load-script'

const ROUTE_NAMES = {
  PROCESSING: 'Processing',
  PAYMENT: 'LinkToPay',
  EXPIRED: 'Expired',
  SUCCESS: 'Success',
  ERROR: 'Error',
  TINABA_PAY: 'TinabaPay'
}

export function getDayJSLocale (locale: string) {
  switch (locale) {
    case 'it': return 'it'
    case 'cn': return 'zh-cn'
    default: return 'en'
  }
}

export function handleAPIError () {
  // Router.replace({ path: 'error', replace: true })
}

export function isPaymentExpired (payment: LinkToPay) {
  return moment(payment.expireDate, 'YYYY-MM-DDTHH:mm:ss.SSSZZ').diff(moment(), 'second') < 0
}

export function checkPaymentErrorAndRedirect (payment: LinkToPay) {
  switch (payment.status) {
    case 'PAYMENT_STARTED':
      if (Router.currentRoute.name === ROUTE_NAMES.PROCESSING) return
      Router.replace({ name: ROUTE_NAMES.PROCESSING, params: { id: `${payment.id}` }, replace: true })
      break;

    case 'EXPIRED':
      if (Router.currentRoute.name === ROUTE_NAMES.EXPIRED) return
      Router.replace({ name: ROUTE_NAMES.EXPIRED, params: { id: `${payment.id}` }, replace: true })
      break;

    case 'PAYMENT_SUCCESS':
      if (Router.currentRoute.name === ROUTE_NAMES.SUCCESS) return
      Router.replace({ name: ROUTE_NAMES.SUCCESS, params: { id: `${payment.id}` }, replace: true })
      break;

    case 'PAYMENT':
      if (Router.currentRoute.name === ROUTE_NAMES.TINABA_PAY) return
      if (Router.currentRoute.name === ROUTE_NAMES.PAYMENT) return

      if (Router.currentRoute.name === ROUTE_NAMES.ERROR) {
        if (payment.errorCode && payment.errorCode !== '') {
          if (Router.currentRoute.name === ROUTE_NAMES.ERROR) return
          Router.replace({ name: ROUTE_NAMES.ERROR, params: { id: `${payment.id}` }, replace: true })
          break;
        }
      }
      Router.replace({ name: ROUTE_NAMES.PAYMENT, params: { id: `${payment.id}` }, replace: true })
      break;

    default:
      if (payment.errorCode && payment.errorCode !== '') {
        if (Router.currentRoute.name === ROUTE_NAMES.ERROR) return
        Router.replace({ name: ROUTE_NAMES.ERROR, params: { id: `${payment.id}` }, replace: true })
        break;
      }
  }
}

export function processAlipayCheckout (checkout: AliPayCheckout) {
  const formEl = document.createElement('form')
  const parameters = checkout.parameters

  //new Alipay responses need just a redirect: parameters are in query string
  if (checkout.method === "GET" && !parameters) {
    window.location.href = checkout.url;
    return;
  }

  for (const key in parameters) {
    const value = parameters[key] as string
    const input = document.createElement('input')
    input.value = value
    input.name = key
    if (key === 'callback') {
      input.value = window.location.href
    }
    formEl.appendChild(input)
  }
  document.body.appendChild(formEl)
  formEl.action = checkout.url
  formEl.method = checkout.method
  formEl.submit()
}

export function loadPaypalSDK ({ clientId, currency, attributionId, clientToken, externalBusinessId }: PaypalData) {
  return new Promise((resolve) => {
    loadOnce(`https://www.paypal.com/sdk/js?client-id=${clientId}&currency=${currency}&intent=capture&disable-funding=mybank,sofort&components=hosted-fields,buttons&merchant-id=${externalBusinessId}`, {
      attrs: {
        'data-partner-attribution-id': attributionId,
        'data-client-token': clientToken
      }
    }, resolve)
  })
}
